import EventBusyIcon from "@mui/icons-material/EventBusy";
import { IconProps } from "./types";

export function CalendarUnavailabilityIcon({ size, ...props }: IconProps) {
    return <EventBusyIcon fontSize={size} {...props} />;
}
